import { AutoMap } from "@automapper/classes";

export class MetrologieDTO {
    @AutoMap()
    debitmetre?: string;
    @AutoMap()
    thermohygroanemometre?: string;
}